import React from 'react';
import cl from 'classnames';
import {CheckSquareOutlined, DeleteOutlined} from '@ant-design/icons';
import { withRouter } from 'react-router-dom';

import s from './Card.module.scss';

class Card extends React.Component {

    state = {
        done: false,
        isRemembered: false,
        isRememberedExactly: false,
    }

    componentDidMount() {
        const {match: {params}, index} = this.props;

        if(index !== undefined) {
            if (index === +params.id) {
                this.setState({
                    done: params.isDone
                });
            }
        }
    }

    handleCardClick = () => {
        this.setState(({done}) =>{
            return {
                done: !done,
            }
        });
    }

    handleIsRememberClick = () => {
        this.setState(({isRemembered}) =>{
            return {
                isRemembered: !isRemembered
            }
        });
    }

    handleIsRememberedExactlyClick = () => {
        this.setState({
            isRememberedExactly: true
        });
    }

    handleIsDeleteClick = () => {
        this.props.onDeleted();
    }

    render() {
        const {id, eng, rus, img} = this.props;
        const { done, isRemembered, isRememberedExactly } = this.state;

        return (
            <div className={s.root}>
                <div
                    className={cl(s.card, {
                        [s.done]: done,
                        [s.isRemembered]: isRemembered,
                        [s.isRememberedExactly]: isRememberedExactly,
                    })}
                    onClick={this.handleCardClick}
                >
                    <div className={s.cardInner}>
                        <div className={s.cardFront}>
                            <img src={img}/>
                            {eng}
                        </div>
                        <div className={s.cardBack}>
                            <img src={img}/>
                            {rus}
                        </div>
                    </div>
                </div>
                <div className={s.icons}>
                    <CheckSquareOutlined onClick={this.handleIsRememberClick}/>
                </div>
                <div className={s.rememberedExactly}>
                    <button className={s.remember} onClick={this.handleIsRememberedExactlyClick}/>
                </div>
                <div className={s.icons}>
                    <DeleteOutlined onClick={this.handleIsDeleteClick}/>
                </div>
            </div>
        )
    }
}

export default withRouter(Card);